import apolloClient from '../../apolloClient';
import emergencyContactListQueries from '../queries/emergencyContactList';
import emergencyContactListMutations from '../mutations/emergencyContactList';

const getEmergencyContactListsByWorkspaceId = async (variables) =>
  apolloClient.query({
    query:
      emergencyContactListQueries.GET_EMERGENCY_CONTACTS_LIST_BY_WORKSPACE_ID,
    fetchPolicy: 'no-cache',
    variables,
  });
const createEmergencyContactList = async (variables) =>
  apolloClient.mutate({
    mutation: emergencyContactListMutations.CREATE_EMERGENCY_CONTACT_LIST,
    fetchPolicy: 'no-cache',
    variables,
  });

const updateEmergencyContactListById = async (variables) =>
  apolloClient.mutate({
    mutation: emergencyContactListMutations.UPDATE_EMERGENCY_CONTACT_LIST,
    fetchPolicy: 'no-cache',
    variables,
  });

const deleteEmergencyContactListById = async (variables) =>
  apolloClient.mutate({
    mutation: emergencyContactListMutations.DELETE_EMERGENCY_CONTACT_LIST_BY_ID,
    fetchPolicy: 'no-cache',
    variables,
  });
export default {
  getEmergencyContactListsByWorkspaceId,
  createEmergencyContactList,
  updateEmergencyContactListById,
  deleteEmergencyContactListById,
};
